import React from 'react'
import { Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import AddNamesToUpdateTreeButton from './AddNamesToUpdateTreeButton'
import AttachImageWithoutTreeUpdatesButton from './AttachImageWithoutTreeUpdatesButton'

export default function NoRecordNamesOnDocument() {
  const { t } = useTranslation()
  const ADD_A_NAME_TEXT = t(
    'noRecordNamesOnDocument.description',
    'Adding a name will include document details from this image to update Family Tree. You can also just attach the image as a source.'
  )
  return (
    <>
      <Paragraph size="sm">{ADD_A_NAME_TEXT}</Paragraph>
      <Separator size="sm" />
      <AddNamesToUpdateTreeButton noPersonsState />
      <Separator size="xs" />
      <AttachImageWithoutTreeUpdatesButton noPersonsState />
    </>
  )
}
